module.exports = __webpack_public_path__ + "static/media/home-changing-3.badc676c.jpg";